import axios from 'axios'
import { IhLogUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查找类别归属列表(查询下拉数据接口)
export function attributeFind(params) {
  const url = IhLogUrl + '/type/attribute/find'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查找类别归属列表', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除类别归属
export function attributeDelete(params) {
  const url = IhLogUrl + '/type/attribute/delete/' + params.id
  return axios({
    method: 'delete',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '删除类别归属', res)
    }
    return Promise.resolve(res.data)
  })
}

//新增类别归属
export function saveAttribute(params) {
  const url = IhLogUrl + '/type/attribute/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '新增类别归属', res)
    }
    return Promise.resolve(res.data)
  })
}

//修改类别归属
export function updateAttribute(params) {
  const url = IhLogUrl + '/type/attribute/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '修改类别归属', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取租户类别归属树数据
export function attributeTree(params) {
  const url = IhLogUrl + '/type/attribute/tree'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '获取租户类别归属树数据', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询类别信息(分页)
export function typePage(params) {
  const url = IhLogUrl + '/media/type/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '查询类别信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除类别归属
export function typeDelete(params) {
  const url = IhLogUrl + '/media/type/delete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(result => {
    if (result.status !== 200 || (!!result.data && result.data.state !== 0)) {
      errorCollection('设备管理', '删除类别归属', result)
    }
    return Promise.resolve(result.data)
  })
}

//类别新增
export function saveType(params) {
  const url = IhLogUrl + '/media/type/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '类别新增', res)
    }
    return Promise.resolve(res.data)
  })
}

//修改类别归属
export function updateType(params) {
  const url = IhLogUrl + '/media/type/update'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res=>{//NOSONAR
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('设备管理', '修改类别归属', res)
    }
    return Promise.resolve(res.data)
  })
}
